import React from "react";

const PrivateRoomsFergusonOutline = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="667"
      height="778"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 667 778"
      xmlSpace="preserve"
      className='clickable'
    >
      <g
        fill="rgba(0,0,0,0)"
        className='object-glow'
        stroke="#ff5c97"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="5"
        transform="translate(-410.5 -118.5)"
      >
        <path d="M416 894l1-738 607 190v361" opacity="1"></path>
        <path d="M416 152l-3-31 662 204-3 368" opacity="1"></path>
        <path d="M1024 345l49-20" opacity="1"></path>
      </g>
    </svg>
  );
}

export default PrivateRoomsFergusonOutline;